import React, { useEffect, useState } from 'react';
import { Stack, Typography } from '@mui/material';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/material/Button';
import { getHistoryEntryById } from '../../../api/historyService';
import { formatToLocalDateTime } from '../../../utils/dateFormatter';
import PostsList from '../lists/PostsList';
import AttachmentsList from '../lists/AttachmentsList';
import DocumentationList from '../lists/DocumentationList';
import LatestVitals from '../display/LatestVitals';

export default function ProcedureView ({ refreshDocumentationList, open, onClose, historyEntry = null }) {

    const handleClose = () => {
      // refreshDocumentationList();
      setSelectedHistoryEntry(null);
      onClose();
    };

    const [selectedHistoryEntry, setSelectedHistoryEntry] = useState(null);

    const [updateFlag, setUpdateFlag] = useState(false);

    const fetchData = async () => {
      const res = await getHistoryEntryById(historyEntry.id);
      setSelectedHistoryEntry(res);

      // Toggle the flag
      setUpdateFlag(prev => !prev);
    };

    useEffect(() => {
        if (open && historyEntry) {
          fetchData();
        }
    }, [open]);

    if (!selectedHistoryEntry) {
        return (
            <></>
        );
    }

    return (
        <React.Fragment>
        <Dialog onClose={handleClose} open={open} disableRestoreFocus>
            <DialogTitle>
                <>
                <Typography variant="body2" sx={{ mt: 0 }}>{`case no. ${historyEntry.history.case_number}`}</Typography>
                <Typography variant="h4" color='primary' component="span" sx={{ mb: 0 }}>{`${historyEntry.type.name}`}</Typography>
                <br />
                <Typography variant="h6" color='primary' component="span" sx={{ mb: 0 }}>{`${historyEntry?.history?.pet?.name} (${historyEntry.history.pet.owner.last_name}, ${historyEntry.history.pet.owner.first_name})`}</Typography>
                <Typography variant="body1" sx={{ mt: 0 }}>{formatToLocalDateTime(historyEntry?.datetime)}</Typography>
                <Typography variant="body2" sx={{ mt: 0, color: 'gray' }}>{`created by ${historyEntry?.user?.name}`}</Typography>
                <LatestVitals
                  updateFlag={updateFlag}
                  pet={historyEntry.history.pet}
                />
                </>
            </DialogTitle>
            <DialogContent dividers>
                <Stack spacing={1}>
                <PostsList 
                  fetchData={fetchData}
                  historyEntry={selectedHistoryEntry}
                  posts={selectedHistoryEntry.posts} 
                />
                <DocumentationList
                  fetchData={fetchData}
                  history={historyEntry.history}
                  historyEntry={selectedHistoryEntry}
                  pet={historyEntry.history.pet}
                />
                <AttachmentsList 
                    fetchData={fetchData}
                    historyEntry={selectedHistoryEntry}
                    attachments={selectedHistoryEntry.attachments}
                />
                </Stack>
            </DialogContent>
            <DialogActions>
                <div style={{flex: '1 0 0'}} />
                <Button onClick={handleClose}>Close</Button>
            </DialogActions>
        </Dialog>
        </React.Fragment>
    );
}